import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Page components
const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const QuotesPage = lazy(() => import('../pages/quotes/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Admin components
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminSubmissions = lazy(() => import('../pages/admin/submissions/page'));
const AdminEmails = lazy(() => import('../pages/admin/emails/page'));
const AdminQuotes = lazy(() => import('../pages/admin/quotes/page'));
const AdminTemplates = lazy(() => import('../pages/admin/templates/page'));
const AdminAnalytics = lazy(() => import('../pages/admin/analytics/page'));
const AdminProducts = lazy(() => import('../pages/admin/products/page'));
const AdminServices = lazy(() => import('../pages/admin/services/page'));
const AdminTestimonials = lazy(() => import('../pages/admin/testimonials/page'));
const AdminSettings = lazy(() => import('../pages/admin/settings/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/quotes',
    element: <QuotesPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/submissions',
    element: <AdminSubmissions />,
  },
  {
    path: '/admin/emails',
    element: <AdminEmails />,
  },
  {
    path: '/admin/quotes',
    element: <AdminQuotes />,
  },
  {
    path: '/admin/templates',
    element: <AdminTemplates />,
  },
  {
    path: '/admin/analytics',
    element: <AdminAnalytics />,
  },
  {
    path: '/admin/products',
    element: <AdminProducts />,
  },
  {
    path: '/admin/services',
    element: <AdminServices />,
  },
  {
    path: '/admin/testimonials',
    element: <AdminTestimonials />,
  },
  {
    path: '/admin/settings',
    element: <AdminSettings />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;